import React from "react";
function Error() {
  return <h1>Error 404 Not found</h1>;
}

export default Error;
